module.exports = __webpack_public_path__ + "9babe5b6bd9662ef90e7872f7a90b3eb.jpg";